import { computed, reactive } from 'vue';

export const addressStepAttributes = [
  'countrycode',
  'emailaddress',
  'firstname',
  'lastname',
  'locality',
  'mobile_number',
  'postalcode',
  'region',
  'salutation',
  'street',
];

export const store = reactive({
  openStep: 'answer',
  answerStepOpen: computed(() => store.openStep === 'answer'),
  addressStepOpen: computed(() => store.openStep === 'address'),
  optOutAccountUpdate: undefined,
  errors: {
    answers: undefined,
    emailaddress: undefined,
    explicitConsent: undefined,
    firstname: undefined,
    lastname: undefined,
    locality: undefined,
    mobile_number: undefined,
    postalcode: undefined,
    region: undefined,
    street: undefined,
  },
  values: {
    answers: undefined,
    countrycode: undefined,
    emailaddress: undefined,
    explicitConsent: undefined,
    firstname: undefined,
    lastname: undefined,
    locality: undefined,
    mobile_number: undefined,
    optOutAccountUpdate: undefined,
    postalcode: undefined,
    region: undefined,
    salutation: undefined,
    street: undefined,
  },
  answerStepValid: computed(() => store.errors.answers === undefined),
  answerErrorUnlocked: false,
  addressStepValid: computed(() => addressStepAttributes.every((name) => store.errors[name] === undefined)),
  addressErrorUnlocked: false,
  addressPrefilled: undefined,
  explicitConsentValid: computed(() => store.errors.explicitConsent === undefined),
  explicitConsentErrorUnlocked: false,
});

export default function initializeStore(defaults) {
  store.values.salutation = defaults.collectAddress
    ? (defaults.prefilledAttributes.salutation || defaults.defaultSalutation)
    : undefined;
  store.values.firstname = defaults.prefilledAttributes.firstname;
  store.values.lastname = defaults.prefilledAttributes.lastname;
  store.values.street = defaults.collectAddress ? defaults.prefilledAttributes.street : undefined;
  store.values.locality = defaults.collectAddress ? defaults.prefilledAttributes.locality : undefined;
  store.values.postalcode = defaults.collectAddress ? defaults.prefilledAttributes.postalcode : undefined;
  store.values.region = defaults.collectAddress ? defaults.prefilledAttributes.region : undefined;
  store.values.countrycode = defaults.collectAddress
    ? (defaults.prefilledAttributes.countrycode || defaults.defaultCountryCode)
    : undefined;
  store.values.emailaddress = defaults.prefilledAttributes.emailaddress;
  store.values.answers = [];
  store.values.explicitConsent = false;

  store.addressPrefilled = Object.values(defaults.prefilledAttributes).some((attribute) => attribute !== undefined);

  return store;
}
